import { createSelector } from 'reselect';

const getTopMenu = (state) => state.topMenu;

export const getCreatePat = createSelector(getTopMenu, (topMenu) => topMenu.createPat);

export const getRevokePat = createSelector(getTopMenu, (topMenu) => topMenu.revokePat);
